// src/components/TripleCtas.jsx
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaFacebookF, FaInstagram, FaYoutube, FaTwitter } from "react-icons/fa";
import { createNewsletterSubscription } from "../lib/firestoreActions";

export default function TripleCtas({
  bookingUrl = "/contact",
  className = "",
  showContact = true,
  settings = {},
}) {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("");
  const [error, setError] = useState("");

  const subscribe = async (event) => {
    event.preventDefault();
    setStatus("");
    setError("");
    try {
      await createNewsletterSubscription(email, "home_cta");
      setEmail("");
      setStatus("Inscription confirmee.");
    } catch (err) {
      setError(err.message || "Email invalide.");
    }
  };

  return (
    <section className={`relative bg-black text-white py-16 ${className}`}>
      <div className="relative px-6 md:px-12">
        <div className={`grid grid-cols-1 gap-8 ${showContact ? "md:grid-cols-3" : "md:grid-cols-2"}`}>
          
          {/* Carte 1 — Nous contacter */}
          {showContact && <div className="bg-white text-black rounded-xl p-8 shadow-[0_10px_30px_rgba(0,0,0,0.2)]">
            <h3 className="text-3xl md:text-4xl font-extrabold leading-tight uppercase">
              {settings.contactTitle || "Vous cherchez quelque chose ?"}
            </h3>
            <p className="readable-copy mt-4 text-gray-700">
              {settings.contactDescription || "Besoin d’un devis, d’un mix, ou d’un renseignement rapide ? Écris-nous et on te répond vite."}
            </p>
            <div className="mt-8 flex justify-between items-center">
              <div className="flex items-center gap-3">
                <div className="w-16 h-16 rounded-full border-2 border-black grid place-items-center">
                  <span className="text-2xl">→</span>
                </div>
                <span className="font-black uppercase tracking-wide">Contacter</span>
              </div>
              <Link
                to={settings.contactUrl || bookingUrl}
                className="px-5 py-2 rounded-full bg-black text-white font-semibold hover:opacity-90 transition"
              >
                {settings.contactLabel || "Nous écrire"}
              </Link>
            </div>
          </div>}

          {/* Carte 2 — Newsletter */}
          <div className="bg-white text-black rounded-xl p-8 shadow-[0_10px_30px_rgba(0,0,0,0.2)]">
            <h3 className="text-3xl md:text-4xl font-extrabold leading-tight uppercase">
              {settings.newsletterTitle || "Inscrivez-vous à notre newsletter !"}
            </h3>
            <p className="readable-copy mt-4 text-gray-700">
              {settings.newsletterDescription || "Reste informé des nouvelles sessions, sorties et offres du studio & label."}
            </p>
            <form onSubmit={subscribe} className="mt-8">
              <div className="flex items-center gap-3">
                <div className="w-16 h-16 rounded-full border-2 border-black grid place-items-center">
                  <span className="text-2xl">✉️</span>
                </div>
                <span className="font-black uppercase tracking-wide">S’inscrire</span>
              </div>
              <div className="mt-5 flex flex-col gap-3 sm:flex-row">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="email@exemple.com"
                  className="min-w-0 flex-1 rounded-full border border-black/15 px-4 py-2 text-sm outline-none focus:border-black"
                  required
                />
                <button className="rounded-full bg-black px-5 py-2 text-sm font-semibold text-white transition hover:opacity-90">
                  Valider
                </button>
              </div>
              {status && <p className="mt-3 text-sm font-semibold text-green-700">{status}</p>}
              {error && <p className="mt-3 text-sm font-semibold text-red-700">{error}</p>}
            </form>
          </div>

          {/* Carte 3 — Rejoignez-nous sur les réseaux */}
          <div className="bg-white text-black rounded-xl p-8 shadow-[0_10px_30px_rgba(0,0,0,0.2)]">
            <h3 className="text-3xl md:text-4xl font-extrabold leading-tight uppercase">
              {settings.socialTitle || "Rejoignez-nous sur les réseaux !"}
            </h3>
            <p className="readable-copy mt-4 text-gray-700">
              {settings.socialDescription || "Suivez Unlimited Session pour découvrir nos dernières actus, artistes et sorties."}
            </p>
            <div className="mt-8 flex gap-4">
              <a href={settings.facebookUrl || "https://facebook.com"} target="_blank" rel="noopener noreferrer" aria-label="Facebook"
                className="w-12 h-12 rounded-full bg-black text-white grid place-items-center hover:opacity-90 transition">
                <FaFacebookF />
              </a>
              <a href={settings.instagramUrl || "https://instagram.com"} target="_blank" rel="noopener noreferrer" aria-label="Instagram"
                className="w-12 h-12 rounded-full bg-black text-white grid place-items-center hover:opacity-90 transition">
                <FaInstagram />
              </a>
              <a href={settings.youtubeUrl || "https://youtube.com"} target="_blank" rel="noopener noreferrer" aria-label="YouTube"
                className="w-12 h-12 rounded-full bg-black text-white grid place-items-center hover:opacity-90 transition">
                <FaYoutube />
              </a>
              <a href={settings.twitterUrl || "https://twitter.com"} target="_blank" rel="noopener noreferrer" aria-label="Twitter"
                className="w-12 h-12 rounded-full bg-black text-white grid place-items-center hover:opacity-90 transition">
                <FaTwitter />
              </a>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
